/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
// import { SwitchInput } from '../../components/inputs/table/SwitchInput';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems } from '../../utils/FormatFunctions';
import { RowIdentity } from '../../components/ui';
// import { onToggleSwitch } from '../../utils/onToggleFunctions';
import { SelectFilter } from '../../components/inputs/filters/select';
import { useAuth } from '../../providers/auth';

export function TeachersPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users?group_id=4`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const groupIds = user?.group?.id;

  const { requestApi: reqApiInstitution, data: dataInstitution } = useFetch(
    `${baseApiUrl}/institutions`
  );
  // const { requestApi: requestToggle } = useFetch(`${baseApiUrl}/globals`);

  const columns = [
    { name: 'name', label: 'Nome' },
    { name: 'institutions', label: 'Instituições' },
  ];

  useEffect(() => {
    reqApiInstitution('get');
  }, []);

  return (
    <Box>
      <PageTitle description="Gerencie os professores e as instituições de cada um.">
        Professores
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 3 ? true : false}
        loading={loading}
        rowActions={{ show: false, edit: groupIds !== 3, delete: groupIds !== 3 }}
        columnWithAction={[
          {
            name: 'name',
            columnAction: (rowItem) => (
              <RowIdentity
                title={rowItem?.name}
                meta={rowItem?.email}
                image={rowItem?.image?.medium}
              />
            ),
          },
        ]}
        formatColum={[
          {
            field: 'institutions',
            formatField: getArrayItems,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
          {
            name: 'institution_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar instituição',
            isSearchable: true,
            onInputChange: (value) => {
              reqApiInstitution('get', { params: { search: value } });
            },
            options: [
              ...(dataInstitution?.data?.map((item) => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
        ]}
      />
    </Box>
  );
}
